import DoctorList from "./DoctorList";

const PatientHome = ({ showAlert }) => {
    return <DoctorList showAlert={showAlert} />;
};

export default PatientHome;
